import { useLocation } from 'react-router-dom';
import qs from 'util/qs';

export default function useQueryString() {
  const location = useLocation();
  const queryString = qs.parse(location.search) || {};

  return queryString;
}
